module.exports = __webpack_public_path__ + "static/media/IconCulinaryLogo.7d5a1b5f.png";